// Real-competition league tables for the "Table" tab of the League Home.
//
// NOTE: HeadToHead's own competition (the per-round division ladder) is fully
// engine-driven and lives in Firestore. The *real* football league table shown
// here is a separate, read-only reference fed by the data provider (API-Football).
// That ingest isn't wired yet, so this module ships a static snapshot for the
// leagues we have design data for; the Table tab degrades to a "coming soon"
// state for any league not listed here. When the standings ingest lands, swap
// LEAGUE_TABLES for a Firestore-backed hook with the same row shape.

export type TableBorder = 'ucl' | 'europa' | 'relegation';

export interface TableRow {
  rank: number;
  code: string;
  name: string;
  /** Played. */
  played: number;
  /** Goal difference. */
  gd: number;
  points: number;
  /** Left-edge accent for a qualification/relegation zone. */
  border?: TableBorder;
  /** Render a labelled divider line above this row. */
  dividerBefore?: 'CHAMPIONS LEAGUE' | 'RELEGATION';
  /** Render a "…" gap (skipped mid-table rows) above this row. */
  gapBefore?: boolean;
}

export interface LeagueTable {
  /** As-of label, e.g. "After MW27". */
  asOf: string;
  rows: TableRow[];
}

export const LEAGUE_TABLES: Record<string, LeagueTable | undefined> = {
  'premier-league': {
    asOf: 'After MW27',
    rows: [
      { rank: 1, code: 'MCI', name: 'Man City', played: 27, gd: 44, points: 64, border: 'ucl' },
      { rank: 2, code: 'ARS', name: 'Arsenal', played: 27, gd: 38, points: 62, border: 'ucl' },
      { rank: 3, code: 'LIV', name: 'Liverpool', played: 27, gd: 30, points: 58, border: 'ucl' },
      { rank: 4, code: 'AVL', name: 'Aston Villa', played: 27, gd: 12, points: 51, border: 'ucl' },
      { rank: 5, code: 'TOT', name: 'Spurs', played: 27, gd: 9, points: 49, dividerBefore: 'CHAMPIONS LEAGUE' },
      { rank: 6, code: 'MUN', name: 'Man United', played: 27, gd: 4, points: 44 },
      { rank: 7, code: 'CHE', name: 'Chelsea', played: 27, gd: 2, points: 42, border: 'europa' },
      { rank: 18, code: 'LUT', name: 'Luton', played: 27, gd: -21, points: 21, border: 'relegation', gapBefore: true, dividerBefore: 'RELEGATION' },
      { rank: 19, code: 'BUR', name: 'Burnley', played: 27, gd: -28, points: 16, border: 'relegation' },
      { rank: 20, code: 'SHU', name: 'Sheffield Utd', played: 27, gd: -39, points: 13, border: 'relegation' }
    ]
  }
};
